/* istanbul ignore file */
import { isModuleAllowed } from '@lumapps/directories/ducks/selectors';
import { connect } from '@lumapps/redux/react';
import { BackOfficeStore } from '@lumapps/redux/types';

import { ModuleSideNavigation } from './ModuleSideNavigation';

const mapStateToProps = (state: BackOfficeStore) => {
    const isAllowed = isModuleAllowed(state);

    return {
        isAllowed,
    };
};

const mapDispatchToProps = {};

const ConnectedModuleSideNavigation = connect(mapStateToProps, mapDispatchToProps)(ModuleSideNavigation);

export { ConnectedModuleSideNavigation as ModuleSideNavigation };
